/*
 * @Author: hfxie
 * @Date: 2022-08-17 17:23:53
 * @LastEditors: hfxie
 * @LastEditTime: 2022-08-17 17:43:40
 * @Description: file content
 */
import * as utils from "@/utils/ganttUnit.js";

const getter = {
  demo(state, getters) {
    return "demo getter";
  },
};
export default getter;
